import { FCX } from "@datassential/platform-ui-lib";
import './Experience.scss';

const FoodExperience: FCX<{
    knowItValue: number;
    haveTriedItValue: number;
}> = ({
    knowItValue,
    haveTriedItValue,
}) => {
    return (
        <div className="FoodExperience">
            <div className="FoodExperience__row">
                <div className="FoodExperience__value">
                    <div
                        className="FoodSectionConsumer__blur"
                        data-testid="textFoodConsumerExperienceKnowItValue"
                    >
                        {Math.round(knowItValue)}
                    </div>
                </div>
                <div
                    className="FoodExperience__label"
                    data-testid="textFoodConsumerExperienceKnowItLabel"
                >
                    know it
                </div>
            </div>
            <div className="FoodExperience__row">
                <div className="FoodExperience__value">
                    <div
                        className="FoodSectionConsumer__blur"
                        data-testid="textFoodConsumerExperienceHaveTriedItValue"
                    >
                        {Math.round(haveTriedItValue)}
                    </div>
                </div>
                <div
                    className="FoodExperience__label"
                    data-testid="textFoodConsumerExperienceHaveTriedItLabel"
                >
                    have<br/>tried it
                </div>
            </div>
        </div>
    );
};

export default FoodExperience;